module.exports = __webpack_public_path__ + "static/media/step-three-big.19119c56.webp";